{
  "general": {
    "title": "Optionen vergleichen",
    "intro": "Ein kurzer Überblick über den Unterschied zwischen einer Gemeinschaftsversion, einem Abonnement und einer Vollversion.",
    "tableheader": "Abonnement",
    "note1": "* Sammelbestellungen und Mengenrabatte möglich.",
    "note2": "** Unterstützte Sprachen Dansk, Deutsch, English, Español, Suomi, Français, Italiano, Norsk, Polski, Português (Brasil), Русский, Svenska",
    "note3": "*** Erfordert ein kostenloses myboardmaker.com-Gemeinschaftskonto und ist ausschließlich für das Speichern von Aktivitäten vorgesehen."
  },
  "columnHeadings": {
    "community": "GEMEINSCHAFT",
    "onetime": "VOLLVERSION*",
    "personal": "EINZELLIZENZ",
    "professional": "EXPERTENLIZENZ",
    "organization": "UNTERNEHMENSLIZENZ*"
  },
  "mobileHeadings": {
    "community": "Gemeinschaft",
    "onetime": "Vollversion*",
    "personal": "Einzellizenz",
    "professional": "Expertenlizenz",
    "organization": "Unternehmenslizenz*"
  },
  "rowHeadings": {
    "editor": "Boardmaker 7 Editor",
    "activations": "Aktivierungen",
    "languages": "Sprachen**",
    "licensing": "Lizenzierung",
    "pcsSymbols": "PCS-Symbole",
    "templates": "Vorlagen",
    "studentCenter": "Boardmaker 7 Student Center",
    "playActivitiesInstructor": "Aktivitäten als Lehrer*in abspielen",
    "playActivitiesStudent": "Aktivitäten als Schüler*in abspielen",
    "myBoardmaker": "myBoardmaker",
    "instructorManagement": "Lehrerverwaltung",
    "studentManagement": "Schülerverwaltung",
    "assignStudentActivities": "Schüleraktivitäten zuweisen",
    "cloudStorage": "Cloudspeicher",
    "createAndJoin": "Gruppen erstellen und beitreten",
    "accessCommunity": "Zugang zu über 120.000 Gemeinschaftsaktivitäten",
    "shareActivity": "Aktivitäten in der Gemeinschaft teilen",
    "curriculum": "Lehrplan und Inhalt",
    "activitiesToGo": "Boardmaker-Aktivitäten zum Mitnehmen",
    "instructionalSolutions": "Lehrlösungen",
    "premiumActivities": "Premium-Aktivitäten",
    "coreFirstLearning": "Core First Learning"
  },
  "rowValues": {
    "byDevice": "2 Geräte",
    "unlimited": "Unbegrenzt",
    "byKey": "Lizenzschlüssel",
    "symbols": "80.000+",
    "templates": "600+",
    "languages": "12",
    "login": "Einloggen",
    "yes": "Ja",
    "yesNote": "Ja***",
    "no": "Nein"
  }
}